const formateaRut = function(rut) {
  let actual = rut.replace(/^0+/, "");
  let rutPuntos = "";
  if (actual != "" && actual.length > 1) {
    let sinPuntos = actual.replace(/\./g, "");
    let actualLimpio = sinPuntos.replace(/-/g, "");
    let inicio = actualLimpio.substring(0, actualLimpio.length - 1);
    let j = 1;
    for (let i = inicio.length - 1; i >= 0; i--) {
      let letra = inicio.charAt(i);
      rutPuntos = letra + rutPuntos;
      if (j % 3 == 0 && j <= inicio.length - 1) {
        rutPuntos = "." + rutPuntos;
      }
      j++;
    }
    let dv = actualLimpio.substring(actualLimpio.length - 1);
    rutPuntos = rutPuntos + "-" + dv;
  } else {
    rutPuntos = rut;
  }
  return rutPuntos;
};

export default {
  formateaRut
};



// WEBPACK FOOTER //
// ./src/assets/js/formatoRut.js